const hashtagType={
    START_FETCHING_HASHTAG:"START_FETCHING_HASHTAG",
    SUCCESS_FETCHIED_HASHTAG:"SUCCESS_FETCHIED_HASHTAG",
    FAILURE_FETCHED_HASHTAG:"FAILURE_FETCHED_HASHTAG",
}

export default hashtagType;